export const AD_LOADED                 = 'AdLoaded';
export const AD_STARTED                = 'AdStarted';
export const AD_STOPPED                = 'AdStopped';
export const AD_SKIPPED                = 'AdSkipped';
export const AD_SKIPPABLE_STATE_CHANGE = 'AdSkippableStateChange';
export const AD_SIZE_CHANGE            = 'AdSizeChange';
export const AD_LINEAR_CHANGE          = 'AdLinearChange';
export const AD_DURATION_CHANGE        = 'AdDurationChange';
export const AD_EXPANDED_CHANGE        = 'AdExpandedChange';
export const AD_REMAINING_TIME_CHANGE  = 'AdRemainingTimeChange';
export const AD_VOLUME_CHANGE          = 'AdVolumeChange';
export const AD_IMPRESSION             = 'AdImpression';
export const AD_VIDEO_START            = 'AdVideoStart';
export const AD_VIDEO_FIRST_QUARTILE   = 'AdVideoFirstQuartile';
export const AD_VIDEO_MIDPOINT         = 'AdVideoMidpoint';
export const AD_VIDEO_THIRD_QUARTILE   = 'AdVideoThirdQuartile';
export const AD_VIDEO_COMPLETE         = 'AdVideoComplete';
export const AD_CLICK_THRU             = 'AdClickThru';
export const AD_INTERACTION            = 'AdInteraction';
export const AD_USER_ACCEPT_INVITATION = 'AdUserAcceptInvitation';
export const AD_USER_MINIMIZE          = 'AdUserMinimize';
export const AD_USER_CLOSE             = 'AdUserClose';
export const AD_PAUSED                 = 'AdPaused';
export const AD_PLAYING                = 'AdPlaying';
export const AD_LOG                    = 'AdLog';
export const AD_ERROR                  = 'AdError';


// WEBPACK FOOTER //
// ./src/Enum/VPAIDEvents.js